import script from "./PageReader.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReader.vue?vue&type=script&setup=true&lang=js"

import "./PageReader.vue?vue&type=style&index=0&id=e4d08116&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4d08116"]])

export default __exports__